import * as React from "react";
import {Button, TextField} from "web-com";
import DocUpload from "myshubhlife-component/docInput";
import {useState} from "react";

interface IProps {
    onClick?: (file: string, password: string) => void;
}

const UploadPdf = (props: IProps) => {
    const [file, updateFile] = useState({bs64: null, isEncrypt: false});
    const [password, updatePassword] = useState(null);
    const [error, setError] = useState(null);
    const onDocInputChange = (bs64: string, name: string, isEncrypt: boolean) => {
        updateFile({bs64, isEncrypt});
        setError(null);
    };
    const buttonOnClick = () => {
        if (!file.bs64) {
             setError("Please select file");
        } else if (file.isEncrypt && !password) {
             setError("Looks like pdf is password enabled, please enter your password below to process the bank statement");
        } else {
            props.onClick(file.bs64, password);
        }
    };

    const onInputFieldChange = (fieldName: string, value: string) => {
        setError(null);
        updatePassword(value);
    };

    return(
        <div className="bs-doc-upload-container">
            <DocUpload
                type= "BANK_STATEMENT_PDF"
                primaryLabel="Choose File"
                handleFileInput={onDocInputChange}
                acceptType={"application/pdf"}
                errorMsg={error}
                isUploaded={!!file.bs64}
            />
            {
                error && <div className="text-danger">{error}</div>
            }
            <TextField
                type="text"
                fieldName="password"
                onChange={onInputFieldChange}
                placeholder={"Enter password if any"}
                value={password}
            />
            <Button buttonText="Click here to upload" onClick={buttonOnClick} rounded={true}/>
        </div>
    );
};

export default UploadPdf;
